import {useEffect, useState} from "react";
import {STATUSES} from "../../../_competition/const";
import {API, Competition, CompetitionAPI, PageModel} from "@brg/api";
import {useTranslation} from "react-i18next";


export const useGetCompetitionList = (competitionIds?: string[], projectId?: string, isExamOwner?: boolean, time?: number) => {

    const [competitionsWinner, setCompetitionsWinner] = useState<Competition[]>([]);
    const [competitionsParticipant, setCompetitionsParticipant] = useState<Competition[]>([]);
    const [competitionsExamCompleted, setCompetitionsExamCompleted] = useState<Competition[]>([]);
    const [competitionFynalist, setIsCompetitionFynalist] = useState<Competition[]>([]);
    const [competitionLMSInfo, setCompetitionLMSInfo] = useState<''>('');
    const [competitionInfo, setCompetitionInfo] = useState<{ name: string, id: string }>({
        name: '',
        id: ''
    });
    const { i18n } = useTranslation();

    useEffect(() => {
        //@ts-ignore
        if (competitionIds?.length > 0 && projectId) {
            const competitionStatus: number[] = [ STATUSES.Open.valueOf(), STATUSES.Voting.valueOf(), STATUSES.Summarizing.valueOf(), STATUSES.Completed.valueOf() ];
            
            CompetitionAPI.GetList({ initTags: true, competitionIds: competitionIds, competitionStatus: competitionStatus, exams: true, includeRatings: true })
                .then((v) => v.json())
                .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
                .then((v) => {

                    setCompetitionsParticipant(v.data.filter(x => x.status !== STATUSES.Completed.valueOf()));
                    //@ts-ignore
                    setCompetitionsExamCompleted(v.data.filter(x => x.status === STATUSES.Completed.valueOf() && x?.lmsModuleProjectId));
                    //@ts-ignore
                    setCompetitionsWinner(v.data.filter(x => x.status === STATUSES.Completed.valueOf() && x.nominations[0].winnerPositions.map(x => x.winnerId).includes(projectId)));
                    setIsCompetitionFynalist(v.data.filter(x => x.status === STATUSES.Completed.valueOf() && x.nominations[0].finalistsID?.includes(projectId)));
                     //@ts-ignore
                    setCompetitionLMSInfo(v.data.find(x => x?.lmsModuleProjectId)?.lmsModuleProjectId || '');
                    setCompetitionInfo({
                        name: v.data?.[0]?.name || '',
                        id: v.data?.[0]?.competitionId
                    })
                });
        }
    }, [competitionIds, i18n.language, projectId, time]);

    return {
        competitionsWinner,
        competitionsParticipant,
        competitionInfo,
        competitionFynalist,
        competitionLMSInfo,
        competitionsExamCompleted: isExamOwner ? competitionsExamCompleted : []
    }
}import {useEffect, useState} from "react";
import {STATUSES} from "../../../_competition/const";
import {API, Competition, CompetitionAPI, PageModel} from "@brg/api";
import {useTranslation} from "react-i18next";


export const useGetCompetitionList = (competitionIds?: string[], projectId?: string, isExamOwner?: boolean, time?: number) => {

    const [competitionsWinner, setCompetitionsWinner] = useState<Competition[]>([]);
    const [competitionsParticipant, setCompetitionsParticipant] = useState<Competition[]>([]);
    const [competitionsExamCompleted, setCompetitionsExamCompleted] = useState<Competition[]>([]);
    const [competitionFynalist, setIsCompetitionFynalist] = useState<Competition[]>([]);
    const [competitionLMSInfo, setCompetitionLMSInfo] = useState<''>('');
    const [competitionInfo, setCompetitionInfo] = useState<{ name: string, id: string }>({
        name: '',
        id: ''
    });
    const { i18n } = useTranslation();

    useEffect(() => {
        //@ts-ignore
        if (competitionIds?.length > 0 && projectId) {
            const competitionStatus: number[] = [ STATUSES.Open.valueOf(), STATUSES.Voting.valueOf(), STATUSES.Summarizing.valueOf(), STATUSES.Completed.valueOf() ];
            
            CompetitionAPI.GetList({ initTags: true, competitionIds: competitionIds, competitionStatus: competitionStatus, exams: true, includeRatings: true })
                .then((v) => v.json())
                .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
                .then((v) => {

                    setCompetitionsParticipant(v.data.filter(x => x.status !== STATUSES.Completed.valueOf()));
                    //@ts-ignore
                    setCompetitionsExamCompleted(v.data.filter(x => x.status === STATUSES.Completed.valueOf() && x?.lmsModuleProjectId));
                    //@ts-ignore
                    setCompetitionsWinner(v.data.filter(x => x.status === STATUSES.Completed.valueOf() && x.nominations[0].winnerPositions.map(x => x.winnerId).includes(projectId)));
                    setIsCompetitionFynalist(v.data.filter(x => x.status === STATUSES.Completed.valueOf() && x.nominations[0].finalistsID?.includes(projectId)));
                     //@ts-ignore
                    setCompetitionLMSInfo(v.data.find(x => x?.lmsModuleProjectId)?.lmsModuleProjectId || '');
                    setCompetitionInfo({
                        name: v.data?.[0]?.name || '',
                        id: v.data?.[0]?.competitionId
                    })
                });
        }
    }, [competitionIds, i18n.language, projectId, time]);

    return {
        competitionsWinner,
        competitionsParticipant,
        competitionInfo,
        competitionFynalist,
        competitionLMSInfo,
        competitionsExamCompleted: isExamOwner ? competitionsExamCompleted : []
    }
}